module.exports = __webpack_public_path__ + "878a3436b34995a2aa0d850919b69a24.mp4";